module.exports = __webpack_public_path__ + "static/img/identity1.4e63a52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/identity1.png
// module id = MIxb
// module chunks = 1